import { parseHtml } from 'FrontRoyalAngular/html.utils';
import { Text } from 'Text';

type Props = {
    subtitle: string;
    title: string;
};

export function ImportantCtaBoxHeader({ subtitle, title }: Props) {
    return (
        <div data-id="important-cta-box-header" className="mb-3">
            <hgroup className="flex flex-col items-center justify-center">
                {subtitle && (
                    <Text as="p" className="mb-1 mt-0 text-center text-xs" color="slate-grey" weight="semibold">
                        {parseHtml(subtitle)}
                    </Text>
                )}
                <Text as="h3" className="m-0 text-center text-[25px]" color="black" weight="normal">
                    {title}
                </Text>
            </hgroup>
        </div>
    );
}
